import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ContentBuilderFieldColors } from '@shared/interfaces/content-builder.interface';

@Component({
  selector: 'app-kiosk-register-confirmation-step',
  template: `
    <div class="flex flex-col gap-12 justify-center items-center">
      <h1
        class="font-bold text-4xl w-full text-center"
        [style.color]="accentColor | contentBuilderColor"
      >
        {{ 'como.create-or-link-account.kiosk-register-confirmation-step.title' | translate }}
      </h1>
      <i
        class="icon icon-n-check text-9xl"
        [style.color]="accentColor | contentBuilderColor"
      ></i>
      <div class="w-full">
        <app-button-atom
          size="L"
          [label]="
            'como.create-or-link-account.kiosk-register-confirmation-step.continue' | translate
          "
          type="kiosk-primary"
          [overrideBgColor]="accentColor"
          (click)="onCompleteStep()"
          [full]="true"
        ></app-button-atom>
      </div>
    </div>
  `,
})
export class KioskRegisterConfirmationStepComponent {
  @Output() onComplete = new EventEmitter<void>();

  @Input() accentColor?: ContentBuilderFieldColors;

  onCompleteStep(): void {
    this.onComplete.next();
  }
}
